import React from 'react';

const Male = props => (
  <svg width="54" height="54" viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" opacity=".01" d="M0 0h54v54H0z" />
      <path
        d="M27 7.75c2.901 0 5.25 2.35 5.25 5.25s-2.349 5.25-5.25 5.25a5.25 5.25 0 1 1 0-10.5zm8.25 13.5h-16.5c0 6.102 2.32 9.662 5.25 11.25v9.75h6V32.5c2.927-1.588 5.25-5.148 5.25-11.25z"
        stroke="#28383F"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default Male;
